/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_Undo_TitleInputs */

const en_knp_lookup_undo_title = /** @type {(inputs: Knp_Lookup_Undo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undo`)
};

const fr_knp_lookup_undo_title = /** @type {(inputs: Knp_Lookup_Undo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

const de_knp_lookup_undo_title = /** @type {(inputs: Knp_Lookup_Undo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rückgängig machen`)
};

const it_knp_lookup_undo_title = /** @type {(inputs: Knp_Lookup_Undo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disfare`)
};

const ru_knp_lookup_undo_title = /** @type {(inputs: Knp_Lookup_Undo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отменить`)
};

const es_knp_lookup_undo_title = /** @type {(inputs: Knp_Lookup_Undo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deshacer`)
};

const zh_cn2_knp_lookup_undo_title = /** @type {(inputs: Knp_Lookup_Undo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`撤销`)
};

const ja_knp_lookup_undo_title = /** @type {(inputs: Knp_Lookup_Undo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`元に戻す`)
};

const hi_knp_lookup_undo_title = /** @type {(inputs: Knp_Lookup_Undo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्ववत`)
};

const pt_pt2_knp_lookup_undo_title = /** @type {(inputs: Knp_Lookup_Undo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desfazer`)
};

/**
* | output |
* | --- |
* | "Undo" |
*
* @param {Knp_Lookup_Undo_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_undo_title = /** @type {((inputs?: Knp_Lookup_Undo_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Undo_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_lookup_undo_title(inputs)
	if (locale === "de") return de_knp_lookup_undo_title(inputs)
	if (locale === "it") return it_knp_lookup_undo_title(inputs)
	if (locale === "ru") return ru_knp_lookup_undo_title(inputs)
	if (locale === "es") return es_knp_lookup_undo_title(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_lookup_undo_title(inputs)
	if (locale === "ja") return ja_knp_lookup_undo_title(inputs)
	if (locale === "hi") return hi_knp_lookup_undo_title(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_lookup_undo_title(inputs)
	return en_knp_lookup_undo_title(inputs)
});